<template>
      <v-dialog :max-width="Modal.Processamento.larguraMaxima" persistent v-model="visibilidadeDialogoReadequacao">
          <v-card :min-width="Modal.Processamento.larguraMinima" :max-width="Modal.Processamento.larguraMaxima">
              <v-card-title class="primary modal-title py-0" primary-title>
                  <span><strong>{{itemOuLoteDescricao}}</strong> | Enviar Readequação/Doc. Complementar</span>
                  <v-btn flat depressed @click="eventoFecharModal">
                      <v-icon>close</v-icon>
                  </v-btn>
              </v-card-title>
              <v-layout class="d-flex px-3 pb-2 pt-3">
                <v-flex xs12>
                    <label><strong class="text--secondary">Mensagem do Comprador</strong></label>
                    <p class="p-mensagem-comprador text--secondary text-xs-justify mt-1 pr-2"> {{ mensagemComprador }} </p>
                </v-flex>
              </v-layout>

              <v-divider></v-divider>

              <v-card-text class="my-0">
                  <p class="primary--text text--darken-1 primary lighten-5 font-weight-bold pa-2 d-inline-flex align-start"
                     style="align-items: center; width: 100%; border-radius: 5px;">
                      <v-icon color="primary" class="mr-3" size="25">info</v-icon>
                      <span style="font-size: 12px">Por gentileza, anexe o arquivo de readequação de proposta do item/lote,
                          contendo a sua descrição completa e informações de valores!</span>
                  </p>
                  <anexo-readequacao v-if="visibilidadeDialogoReadequacao" :itemOuLoteReajusteId="itemOuLote.id"
                                     :deveMostrarBotaoAnexarReajuste="deveMostrarBotaoAnexarReajuste"
                                     :nomeArquivoEnviado="getNomeArquivoEnviado"
                                     @propagarEventoEnviarAnexoReadequacao="processarEventoAnexarReadequacao">

                  </anexo-readequacao>
              </v-card-text>

              <v-card-text class="pb-0 az-form-content">
                  <v-textarea v-model="mensagem"
                              name="'Observação Reajuste Item/Lote'"
                              label="Mensagem"
                              placeholder="Digite aqui a observação"
                              rows="4"
                              maxlength="1000"
                              :counter="1000"/>
              </v-card-text>

                <v-card-actions class="px-3 py-2">
                    <v-btn color="botao-cancelar-color" outline flat @click="eventoFecharModal">
                        Fechar
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn id="botaoConfirmar" color="primary" depressed @click="enviarSolicitacaoReajuste">
                        Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
</template>

<script>
import AnexoReadequacao from '@/views/pages/fornecedor/resultado/documento-proposta/anexo/AnexoReadequacao'
import {Modal} from '@/core/constants'

export default {
    name: 'ModalEnviarReadequacao',
    components: {AnexoReadequacao},
    $_veeValidate: {
        validator: 'new'
    },
    props: ['itemOuLote', 'anexoReadequacao', 'visibilidadeDialogoReadequacao'],
    data() {
        return {
            mensagem: null,
            Modal,
        }
    },
    computed:{
        itemOuLoteDescricao(){
            return this.itemOuLote.identificacaoSequencial ? this.itemOuLote.identificacaoSequencial : this.itemOuLote.rotulo
        },
        getNomeArquivoEnviado(){
            if(this.anexoReadequacao && this.anexoReadequacao.nome){
                const nome = this.anexoReadequacao.nome
                if (nome.length > 50)
                    return nome.substring(0,45).concat('...')

                return nome
            }
            return 'Arquivo anexado'
        },
        deveMostrarBotaoAnexarReajuste(){
            return !this.anexoReadequacao || !this.anexoReadequacao.uri
        },
        ehItem(){
            return this.itemOuLote.itemCompraDiretaId
        },
        mensagemComprador(){
            return this.itemOuLote.observacaoReadequacao || 'Não há mensagem'
        },
    },
    methods: {
        async enviarSolicitacaoReajuste(){
            await this.validarPreenchimento()

            const dados = {
                itemOuLoteReajusteId: this.itemOuLote.id,
                compraDiretaId: this.itemOuLote.compraDiretaId,
                documentoApresentadoId: this.itemOuLote.documentoApresentadoId,
                observacao: this.mensagem,
                uri: this.anexoReadequacao.uri
            }

            if(this.ehItem){
                dados.tipo = 'ITEM'
                dados.itemOuLoteId = this.itemOuLote.itemCompraDiretaId
            }else{
                dados.tipo = 'LOTE'
                dados.itemOuLoteId = this.itemOuLote.loteCompraDiretaId
            }

            this.$emit('propagarEventoatualizarReadequacaoItemLote', dados)
            this.limparCampos()
        },
        async validarPreenchimento() {
            if (!this.anexoReadequacao || !this.anexoReadequacao.uri) {
                throw new Error('Anexe o arquivo de readequação')
            }
        },
        eventoFecharModal(){
            this.$emit('fecharModalReadequacao')
            this.limparCampos()
        },
        limparCampos() {
            this.mensagem = null
            this.$validator.reset()
        },
        processarEventoAnexarReadequacao(arquivoAnexado){
            this.$emit('propagarEventoEnviarAnexoReadequacao', arquivoAnexado)
        }
    },
}
</script>

<style scoped lang="stylus">
    a.botao-enviar-reajuste *
        background-color transparent

    a.botao-enviar-reajuste
        min-width 50px
        font-size 14px
        display block

    a.deshabilidato
        pointer-events none


    .primary-color
        color var(--v-primary--text) !important

    .secondary-color
        color var(--v-primary--text) !important

    i
        font-size 13px
        top 0


    /* modal */
    .modal-title
        justify-content space-between

        .v-btn
            padding 0
            margin 0
            color #fff
            box-sizing border-box
            min-width 25px

    .botao-primario
        padding 0 25px
        border 1px solid var(--v-primary-base) !important
        background-color var(--v-primary-base) !important
        color #fff !important
        box-sizing border-box
        margin-left 15px !important

    .p-mensagem-comprador
        white-space pre-line !important
        max-height 200px;
        overflow auto
</style>